<div class="person d-flex align-items-center spacing-8 {{ Type }}">
  @if (Type === 'person') {
    <div class="avatar">
      <span class="custom-icon">🤩</span>
    </div>
  }
  @if (Type === 'product') {
    <app-ce-icon [svg_class]="['d-flex', 'primary-50']" [name]="'product'"></app-ce-icon>
  }

  @if (Type === 'attribute') {
    <app-datatypes label="array" size="large" Type="string_text"></app-datatypes>
  }
  @if (Type === 'date-picker') {
    <app-ce-icon [svg_class]="['d-flex', 'primary-50']" [name]="'calendar'"></app-ce-icon>
  }
  @if (Type !== 'multiselect') {
    <span class="name h4-bold primary-100"
      >{{ name }}
      @if (Type === 'person') {
        <span class="mail h4-reg primary-60">{{ mail }}</span>
      }
    </span>
  }

  @if (Type === 'multiselect') {
    <div class="multiselect d-flex align-items-center spacing-4">
      <app-tags [ellipsis]="true" label="Option1" [close]="true"></app-tags>
      <app-tags [ellipsis]="true" label="Option2" [close]="true"></app-tags>
      <app-tags [ellipsis]="true" label="Option3" [close]="true"></app-tags>
    </div>
  }
</div>
